<button
	mat-raised-button
	(click)="_clicked()"
	type="button"
	[disabled]="disabled"
	[TealiumLink]="{ interaction_type: 'button' }"
>
	<template #componentContainer> </template>
	<ng-content *ngIf="!_component" select=".layout"></ng-content>
	<div class="tags" *ngIf="tags && tags.length > 0">
		<div
			class="tag"
			[ngClass]="'tag-' + i"
			*ngFor="let tag of tags; let i = index"
		>
			<img src="/assets/img/badge-dark-triangle.svg" />
			{{ tag }}
		</div>
	</div>

	<div class="toggle-icon" *ngIf="!disabled && isRadio">
		<div class="blank" *ngIf="!__active">
			<img src="assets/img/icons/blank.svg" alt="blank" />
		</div>
		<div class="radio" *ngIf="__active">
			<img src="assets/img/icons/radio.svg" alt="radio" />
		</div>
	</div>
	<div class="toggle-icon" *ngIf="disabled && isRadio">
		<div class="blank">
			<img src="assets/img/icons/radio-disabled.svg" alt="disabled" />
		</div>
	</div>
	<div class="toggle-icon" *ngIf="!disabled && isCheckBox">
		<div class="blank" *ngIf="!__active">
			<img src="assets/img/icons/square.svg" alt="blank" />
		</div>
		<div class="radio" *ngIf="__active">
			<img src="assets/img/icons/square-ticked.svg" alt="radio" />
		</div>
	</div>
</button>

<div *ngIf="promoDescription" class="dodo-cta-features-pointer" [style.height.px]="10" [style.margin-bottom.px]="-10">
	<div
		class="pointer"
		[style.width.px]="28"
		[style.height.px]="15"
		[style.left.px]="120"
	>
		<div class="content" [style.width.px]="20" [style.height.px]="20"></div>
	</div>
</div>

<mat-card appearance="outlined" *ngIf="promoDescription">
	<div class="contents">
		<div class="promo-icon">
			<img src="assets/img/icons/promo-discount.svg" />
		</div>
		<div class="promo-text" [innerHTML]="promoDescription"></div>
	</div>
</mat-card>
<div class="title-below-button" *ngIf="titleBelowButton">
	{{ titleBelowButton }}
</div>

<!-- <div class="button-below-features" *ngIf="buttonBelowFeatures">
	<ul *ngIf="buttonBelowFeatures && buttonBelowFeatures.length > 0">
		<li *ngFor="let buttonBelowFeature of buttonBelowFeatures">
			<img src="/assets/img/icons/icon-tick-purple.png" alt="" />
			<span [innerHtml]="buttonBelowFeature"></span>
		</li>
	</ul>
</div> -->

<ng-content select="[info]"></ng-content>
